import { render } from "./ShowBrands.vue?vue&type=template&id=3531de98"
import script from "./ShowBrands.vue?vue&type=script&lang=js"
export * from "./ShowBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__